import { useEffect } from 'react';
import type { MenuData } from 'src/types/types';

export const useCafeSeo = (data?: MenuData) => {
  useEffect(() => {
    if (!data) return;

    const cafe = data.cafe;

    const keywords = data.menuItems
      ?.filter((item) => item.available)
      .map((item) => item.name)
      .filter(Boolean)
      .slice(0, 5)
      .join(', ');

    const title = keywords
      ? `${cafe.name} — ${keywords}`
      : `${cafe.name} — QR Меню`;

    const description =
      cafe.tagline?.trim() || `${cafe.name}: перегляньте меню та ціни онлайн`;

    document.title = title;

    setMeta("meta[name='description']", description);
    setMeta("meta[property='og:title']", title);
    setMeta("meta[property='og:description']", description);

    if (cafe.logoUrl) {
      setLink("link[rel='icon']", `${cafe.logoUrl}?tr=w-128,q-80`);
    }
  }, [data]);
};

const setMeta = (selector: string, content: string) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (selector: string, href: string) => {
  let el = document.querySelector<HTMLLinkElement>(selector);
  if (!el) {
    el = document.createElement('link');
    el.rel = 'icon';
    document.head.appendChild(el);
  }
  el.href = href;
};
